<script>
    import TextField from "../../common/text-field.vue";

    export default {
        name: 'widgets-search',
        components: {TextField},
        data() {
            return {
                search: undefined,
                sortBy: 'name',
                sortDir: 'desc'
            }
        },
        computed: {
            sortByItems() {
                return [
                    {value: 'name', text: Lang.langGet("Name")},
                    {value: 'date', text: Lang.langGet("Added at")}
                ];
            },
            translations() {
                return {
                    search: Lang.langGet("Search"),
                    sort: Lang.langGet("Sort by"),
                }
            },
            debouncedHandleChange() {
                return _.debounce(this.handleChange, 500);
            }
        },
        watch: {
            search() {
                EaseEventBus.fire('startSearch', {keyword: this.search});
            },
            sortBy() {
                EaseEventBus.fire('sortBy', {sort_by: this.sortBy, sort_dir: this.sortDir});
            },
            sortDir() {
                EaseEventBus.fire('sortBy', {sort_by: this.sortBy, sort_dir: this.sortDir});
            }
        },
        methods: {
            handleChange(value) {
                this.search = value;
            },
            handleSortBy(value) {
                this.sortBy = value;
            },
            handleSortDir() {
                this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
            }
        },
        mounted() {
            EaseEventBus.listen('updateWidgetlist', () => {
                EaseEventBus.fire('updateWidgetlistData', {keyword: this.search});
            });
        }
    }
</script>

<template>
    <div class="d-flex mb-4">
        <text-field class="bg-white"
            :placeholder="translations.search"
            :label="translations.search"
            :value="search"
            @input="debouncedHandleChange"
            hide-details="auto"
        />
        <div class="mx-2">
            <v-select-custom class="bg-white"
                :value="sortBy"
                @input="handleSortBy"
                :items="sortByItems"
                :label="translations.sort"
                hide-details="auto"
            />
        </div>
        <v-btn aria-label="change sort direction" @click="handleSortDir">
            <i :class="['fa-regular', sortDir === 'asc' ? 'fa-arrow-down' : 'fa-arrow-up']" class="fa-fw"/>
        </v-btn>
    </div>
</template>

<style scoped>
.bg-white {
    background-color: white;
}
</style>
